import React, { useEffect, useState } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';

const POINTS_MALL_PATH = '/points-mall';

/**
 * 仅对积分商城路由做页面实例保活：
 * - 跳转到其他页面时保持挂载（display: none）
 * - 返回积分商城时直接复用原实例，保留滚动与组件状态
 */
const RouteCacheLayout: React.FC = () => {
  const location = useLocation();
  const outlet = useOutlet();
  const isPointsMallRoute = location.pathname === POINTS_MALL_PATH;
  const [cachedPointsMallOutlet, setCachedPointsMallOutlet] = useState<React.ReactNode | null>(null);

  useEffect(() => {
    if (isPointsMallRoute && !cachedPointsMallOutlet) {
      setCachedPointsMallOutlet(outlet);
    }
  }, [isPointsMallRoute, cachedPointsMallOutlet, outlet]);

  const pointsMallView = cachedPointsMallOutlet ?? (isPointsMallRoute ? outlet : null);

  return (
    <>
      {pointsMallView && <div style={{ display: isPointsMallRoute ? 'block' : 'none' }}>{pointsMallView}</div>}
      {!isPointsMallRoute && outlet}
    </>
  );
};

export default RouteCacheLayout;
